import { useState, useEffect } from 'react';
import { Bell, AlertTriangle } from 'lucide-react';
import { useRestaurantStore } from '../store/restaurantStore';

export default function StockAlerts({ compact }) {
  const { ingredients, fetchIngredients, products, fetchProducts } = useRestaurantStore();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    fetchIngredients();
    fetchProducts();
    const interval = setInterval(() => {
      fetchIngredients();
      fetchProducts();
    }, 60000); // Check every minute
    return () => clearInterval(interval);
  }, []);

  const lowStockIngredients = ingredients.filter(ing => ing.stock <= (ing.minStock || 0)).map(ing => ({ ...ing, type: 'Ingrediente' }));
  const lowStockProducts = products.filter(prod => (!prod.recipe || prod.recipe.length === 0) && prod.stock <= (prod.minStock || 0)).map(prod => ({ ...prod, type: 'Producto' }));
  
  const lowStockItems = [...lowStockIngredients, ...lowStockProducts];

  if (lowStockItems.length === 0) return null;

  return (
    <div className="relative">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className={`relative p-2 transition-colors ${compact ? 'text-slate-600 hover:text-primary dark:text-slate-300 dark:hover:text-white' : 'text-white/80 hover:text-white'}`}
      >
        <Bell size={24} className="animate-pulse text-rose-400" />
        <span className="absolute top-0 right-0 w-5 h-5 bg-rose-500 rounded-full text-[10px] font-bold flex items-center justify-center border-2 border-slate-900">
          {lowStockItems.length}
        </span>
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-80 bg-slate-800 border border-white/10 rounded-xl shadow-2xl overflow-hidden z-50 animate-fade-in">
          <div className="bg-rose-500/20 p-4 border-b border-rose-500/20 flex items-center gap-3">
            <AlertTriangle className="text-rose-400" size={20} />
            <h3 className="font-bold text-rose-100">Alertas de Stock</h3>
          </div>
          <div className="max-h-[60vh] overflow-y-auto">
            {lowStockItems.map(item => (
              <div key={item.id} className="p-4 border-b border-white/5 hover:bg-white/5 transition-colors">
                <p className="font-semibold text-white">{item.name}</p>
                <div className="flex justify-between items-center mt-1">
                  <span className="text-sm text-rose-400 font-mono">Actual: {item.stock} {item.unit || ''}</span>
                  <div className="flex flex-col items-end">
                    <span className="text-xs text-slate-400">Mínimo: {item.minStock || 0} {item.unit || ''}</span>
                    <span className="text-[10px] uppercase text-rose-300 font-bold tracking-wider">{item.type}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
